import React, { useState, useEffect } from "react";
import {
  ReportCardFields,
  ReportCardTitle,
  ReportCardBody,
  ReportCard,
  ReportCardButton,
  ReportsPanelContainer,
  ReportsPanelNavBar,
  ReportCardPanel,
  DescriptionButton,
  CointsContainer,
  CointNumber,
  EstimateLabel,
  ReportsAndDropdownPanelContainer,
  ReportCardDetails,
  DaysContainer,
  TwoDaysContainer,
  DaysInputContainer,
  ReportCustomCardButton,
  CustomFieldsModal,
  CustomFieldsModalButton,
  FiltersButton,
  ReportsCardButtonsContainer,
  FilterContainer,
  FilterContainerIcon,
  FiltersButtonTop,
  TopButtonsContainer,
} from "./reportsPanelStyled";
import { useCSV } from "../../../customHooks";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faTag,
  faQuestionCircle,
  faExclamationTriangle,
  faClock,
  faGear,
  faTrashAlt,
} from "@fortawesome/free-solid-svg-icons";
import {
  apiErrorSubject,
  talkingPageySubject,
} from "../../../subjects/subjects";
import { apiRequest, apiRoutes } from "../../../services";
import {
  LoadingSpinner,
  Modal,
  MultiSelectDropdown,
  DragAndDropList,
} from "../../../components";
import { DatePicker, MuiPickersUtilsProvider } from "@material-ui/pickers";
import DateFnsUtils from "@date-io/date-fns";

interface reportsInterface {
  report_name: string;
  report_description: string;
  report_fields: Array<[field: string]>;
  report_file_type: string;
  report_pagey_tokens: string;
  report_url: string;
  estimate_time: string;
  report_details: string;
  report_type: string;
  report_validation_date: string;
}

interface Props {
  domain?: string;
}

export default function ReportsPanel({domain}: Props,) {
  const { downloadCSV } = useCSV();

  const [isLoading, setIsLoading] = useState<null | number>(null);
  const [domainIDs, setDomainIDs] = useState<any>([]);
  const [domainsTypeOptions, setDomainsTypeOptions] = useState<Array<any>>([]);
  const [reports, setReports] = useState<null | Array<reportsInterface>>(null);
  const [fromDate, setFromDate] = useState<any>(null);
  const [toDate, setToDate] = useState<any>(null);
  let [customFieldsModalOpen, setCustomFieldsModalOpen] = useState<any>(null);
  const [openfilters, setOpenfilters] = useState<boolean>(false);
  const [forceUpdate, setForceUpdate] = useState<boolean>(false);

  const dowloadClicked = async (
    API: string,
    reportName: string,
    reportType: string,
    index: number,
    fields: Array<any>
  ) => {
    setIsLoading(index);
    const [error, data] = await downloadCSV(API, reportName, reportType, {
      domains:
        domainIDs.length > 0
          ? domainIDs
          : domainsTypeOptions.map((e) => e["domain-id"]),
      fromDate,
      toDate,
      fields: fields.map((field) => field.field),
    });
    if(error){
      apiErrorSubject.next(
        "Oops a problem occurred with the download, we are solving it."
      );
    }
    setIsLoading(null);
  };

  useEffect(() => {
    fetch_Reports();
    fetch_domains();
  }, []);

  useEffect(() => {
    (fromDate > toDate || !fromDate) && setToDate(null);
  }, [fromDate]);

  const fetch_Reports = async () => {
    const [error, res] = await apiRequest({
      method: "get",
      url: apiRoutes.reports,
    });

    if (res) {
      setReports(res);
    } else {
      if (res === null) {
        apiErrorSubject.next("No Reports found");
      } else {
        console.log("err", error);
        window.location.replace("/unauthorized");
      }
    }
  };

  const fetch_domains = async () => {
    const [error, res] = await apiRequest({
      method: "get",
      url: apiRoutes.domain,
    });
    if (res) {
      setDomainsTypeOptions(res);
    } else {
      console.log("err", error);
      if (res === null) {
        apiErrorSubject.next("No Domains found");
      } else {
        console.log("err", error);
        window.location.replace("/unauthorized");
      }
    }
  };

  const changeObjectCheckedValue = async (name: string) => {
    if (customFieldsModalOpen) {
      customFieldsModalOpen.forEach((element: any) => {
        if (name === element.field)
          element.dontAddToPayload = !element.dontAddToPayload;
      });
      setForceUpdate(!forceUpdate);
    }
  };

  const setAllCheckbox = async (value: boolean) => {
    if (customFieldsModalOpen) {
      customFieldsModalOpen.forEach((element: any) => {
        element.dontAddToPayload = value;
      });
      setForceUpdate(!forceUpdate);
    }
  };

  return (
    <>
      {reports ? (
        <ReportsAndDropdownPanelContainer>
          <ReportsCardButtonsContainer>
            <MultiSelectDropdown
              options={domainsTypeOptions}
              onChange={(reports: string) => setDomainIDs(reports)}
              dropwdownLabel={`${domain ? domain.toUpperCase() : ''} DOMAINS`}
              allOptionsLabel={`All ${domain ? domain : 'PD'} Domains`}
              keyToShow={"domain"}
              keyToReturn={"domain-id"}
            />
            <FiltersButton
              onClick={() => setOpenfilters(!openfilters)}
              title="Open Filters"
              style={{
                fontSize: "25px",
                color: openfilters ? "rgb(6, 172, 56)" : "rgb(227, 227, 227)",
              }}
            >
              <FontAwesomeIcon icon={faGear} id="FiltersButtonId" />
            </FiltersButton>
          </ReportsCardButtonsContainer>
          {openfilters && (
            <TwoDaysContainer>
              <DaysContainer>
                <label>from:</label>
                <FilterContainer>
                  <DaysInputContainer>
                    <MuiPickersUtilsProvider utils={DateFnsUtils}>
                      <DatePicker
                        value={fromDate}
                        format="MMMM dd, yyyy"
                        onChange={(value) => setFromDate(value)}
                      />
                    </MuiPickersUtilsProvider>
                  </DaysInputContainer>
                  <FilterContainerIcon onClick={() => setFromDate(null)}>
                    <FontAwesomeIcon icon={faTrashAlt} />
                  </FilterContainerIcon>
                </FilterContainer>
              </DaysContainer>
              <DaysContainer>
                <label>To:</label>
                <FilterContainer>
                  <DaysInputContainer>
                    <MuiPickersUtilsProvider utils={DateFnsUtils}>
                      <DatePicker
                        minDate={fromDate}
                        value={toDate}
                        format="MMMM dd, yyyy"
                        disabled={!fromDate}
                        onChange={(value) => setToDate(value)}
                      />
                    </MuiPickersUtilsProvider>
                  </DaysInputContainer>
                  <FilterContainerIcon onClick={() => setToDate(null)}>
                    <FontAwesomeIcon icon={faTrashAlt} />
                  </FilterContainerIcon>
                </FilterContainer>
              </DaysContainer>
            </TwoDaysContainer>
          )}
          <ReportsPanelContainer id="ReportPanelId">
            <ReportsPanelNavBar>
              <FontAwesomeIcon
                style={{
                  marginRight: "15px",
                  color: "#06ac38",
                  fontSize: "19px",
                }}
                icon={faTag}
              />{" "}
              REPORTS AVAILABLE
            </ReportsPanelNavBar>
            <ReportCardPanel>
              {reports.map((report, index) => (
                <>
                  {
                    <ReportCard
                      key={report.report_name.toUpperCase()}
                      style={{ animationDelay: 0.5 * index + "s" }}
                    >
                      {isLoading === index ? (
                        <LoadingSpinner
                          widthToUse={"50px"}
                          heightToUse={"50px"}
                          containerHeight={"114px"}
                        />
                      ) : (
                        <ReportCardBody>
                          <ReportCardTitle>
                            {report.report_name.toUpperCase()}
                            <div>
                              {report.report_validation_date && (
                                <DescriptionButton
                                  onClick={() =>talkingPageySubject.next(report.report_validation_date)}
                                >
                                  <FontAwesomeIcon
                                    id={"ClockId" + index}
                                    style={{
                                      cursor: "pointer",
                                      color: "#06ac38",
                                      fontSize: "14px",
                                    }}
                                    icon={faClock}
                                  />
                                </DescriptionButton>
                              )}

                              <DescriptionButton
                                onClick={() =>
                                  talkingPageySubject.next(
                                    report.report_description
                                  )
                                }
                              >
                                <FontAwesomeIcon
                                  id={"QuestionId" + index}
                                  style={{
                                    cursor: "pointer",
                                    color: "#06ac38",
                                    fontSize: "14px",
                                  }}
                                  icon={faQuestionCircle}
                                />
                              </DescriptionButton>
                            </div>
                          </ReportCardTitle>
                          <ReportCardDetails title={report.report_details}>
                            {report.report_details}
                          </ReportCardDetails>
                          <ReportCardFields
                            title={report.report_fields
                              .filter((report: any) => !report.dontAddToPayload)
                              .flatMap((report: any) => report.field)
                              .toString()
                              .toUpperCase()}
                          >
                            FIELDS:{" "}
                            {report.report_fields
                              .filter((report: any) => !report.dontAddToPayload)
                              .flatMap((report: any) => report.field)
                              .toString()
                              .toUpperCase()}
                          </ReportCardFields>
                          <CointsContainer>
                            <ReportCustomCardButton
                              id={"CustomFields" + index}
                              onClick={() =>
                                setCustomFieldsModalOpen(report.report_fields)
                              }
                            >
                              {" "}
                              Custom fields
                            </ReportCustomCardButton>
                            <CointNumber
                              id={"Coin" + index}
                              onClick={() =>
                                talkingPageySubject.next(
                                  `This report has a Pagey token value of ${
                                    report.report_pagey_tokens
                                  } ${
                                    parseInt(report.report_pagey_tokens) > 1
                                      ? "tokens"
                                      : "token"
                                  }.`
                                )
                              }
                            >
                              {report.report_pagey_tokens}
                            </CointNumber>
                          </CointsContainer>
                        </ReportCardBody>
                      )}
                      {report.estimate_time && (
                        <EstimateLabel>
                          <FontAwesomeIcon
                            style={{
                              marginRight: "5px",
                              color: "rgb(255 96 2)",
                              fontSize: "12px",
                            }}
                            icon={faExclamationTriangle}
                          />
                          Estimated Time: {report.estimate_time}
                        </EstimateLabel>
                      )}
                      <ReportCardButton
                        id={"Download" + index}
                        onClick={() =>
                          dowloadClicked(
                            report.report_url,
                            domainIDs.length === 0
                              ? "all_domains"
                              : domainIDs.length === 1
                              ? domainsTypeOptions.filter(
                                  (domain) =>
                                    domain["domain-id"] === domainIDs[0]
                                )[0].domain
                              : "multiple_domains",
                            report.report_file_type,
                            index,
                            report.report_fields.filter(
                              (report: any) => !report.dontAddToPayload
                            )
                          )
                        }
                        disabled={isLoading !== null}
                      >
                        {" "}
                        Download {report.report_file_type.toUpperCase()}
                      </ReportCardButton>
                    </ReportCard>
                  }
                  <Modal
                    show={customFieldsModalOpen}
                    title="Custom Fields"
                    handleClose={() => setCustomFieldsModalOpen(null)}
                    modalFitContent
                    dontShowCloseButton={true}
                  >
                    <TopButtonsContainer>
                      <FiltersButtonTop onClick={() => setAllCheckbox(false)}>
                        Select All
                      </FiltersButtonTop>
                      <FiltersButtonTop onClick={() => setAllCheckbox(true)}>
                        Unselect All
                      </FiltersButtonTop>
                    </TopButtonsContainer>
                    <CustomFieldsModal
                      style={{
                        width:
                          (Math.floor(
                            (customFieldsModalOpen
                              ? customFieldsModalOpen.length
                              : 1) / 9
                          ) +
                            1) *
                            350 +
                          "px",
                      }}
                    >
                      {customFieldsModalOpen &&
                        customFieldsModalOpen.length > 0 && (
                          <DragAndDropList
                            arrayOfOptions={customFieldsModalOpen}
                            onListOrdenChange={(list: Array<any>) => {
                              report.report_fields = list;
                              setForceUpdate(!forceUpdate);
                            }}
                            changeObjectCheckedValue={(label: string) =>
                              changeObjectCheckedValue(label)
                            }
                            labelKey={"field"}
                            checkedKey={"dontAddToPayload"}
                          />
                        )}
                    </CustomFieldsModal>
                    <CustomFieldsModalButton
                      onClick={() => setCustomFieldsModalOpen(null)}
                      disabled={
                        customFieldsModalOpen?.filter(
                          (element: any) => !element.dontAddToPayload
                        ).length === 0
                      }
                    >
                      Close
                    </CustomFieldsModalButton>
                  </Modal>
                </>
              ))}
            </ReportCardPanel>
          </ReportsPanelContainer>
        </ReportsAndDropdownPanelContainer>
      ) : (
        <LoadingSpinner />
      )}
    </>
  );
}
